import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { api } from "@/lib/api";
import { Loader2, CheckCircle2, XCircle, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentsSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = params.get("session_id");
  const [state, setState] = useState({ phase: "polling", data: null });

  useEffect(() => {
    if (!sessionId) {
      setState({ phase: "error", data: { error: "Session manquante" } });
      return;
    }
    let attempts = 0;
    const max = 8;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setState({ phase: "paid", data });
          return;
        }
        if (data.status === "expired") {
          setState({ phase: "expired", data });
          return;
        }
        attempts += 1;
        if (attempts >= max) {
          setState({ phase: "timeout", data });
          return;
        }
        setTimeout(poll, 2000);
      } catch (e) {
        const status = e?.response?.status;
        if (status === 404) {
          setState({ phase: "error", data: { error: "Session de paiement introuvable. Le paiement n'a peut-être pas été initié depuis votre compte." } });
        } else {
          setState({ phase: "error", data: { error: e?.response?.data?.detail || e?.message || "Erreur de vérification du paiement" } });
        }
      }
    };
    poll();
  }, [sessionId]);

  return (
    <Layout withFooter={false}>
      <div className="max-w-md mx-auto px-6 py-24 text-center">
        {state.phase === "polling" && (
          <>
            <Loader2 className="w-12 h-12 mx-auto text-[#D6202C] animate-spin mb-4" />
            <h1 className="font-heading text-3xl font-medium mb-2">Vérification du paiement...</h1>
            <p className="text-muted-foreground">Quelques secondes le temps que Stripe nous confirme la transaction.</p>
          </>
        )}
        {state.phase === "paid" && (
          <>
            <div className="w-16 h-16 mx-auto rounded-full bg-[#2E7D32] text-white flex items-center justify-center mb-4">
              <CheckCircle2 className="w-9 h-9" />
            </div>
            <h1 className="font-heading text-4xl font-medium mb-2">Paiement réussi !</h1>
            <p className="text-muted-foreground mb-6">
              {state.data?.kind === "boost"
                ? "Votre annonce est désormais boostée 🚀 et apparaîtra en tête des résultats."
                : "Bienvenue dans l'espace Pro 🎉 Badge vérifié activé."}
            </p>
            <div className="flex gap-2 justify-center">
              <Button onClick={() => navigate("/dashboard")} className="bg-[#D6202C] hover:bg-[#B5181F] rounded-full">
                <Sparkles className="w-4 h-4 mr-1" /> Aller au dashboard
              </Button>
            </div>
          </>
        )}
        {(state.phase === "expired" || state.phase === "timeout" || state.phase === "error") && (
          <>
            <div className="w-16 h-16 mx-auto rounded-full bg-red-100 text-red-600 flex items-center justify-center mb-4">
              <XCircle className="w-9 h-9" />
            </div>
            <h1 className="font-heading text-3xl font-medium mb-2">
              {state.phase === "expired" ? "Session expirée" : state.phase === "timeout" ? "Délai dépassé" : "Erreur"}
            </h1>
            <p className="text-muted-foreground mb-6">
              {state.data?.error || "Veuillez réessayer ou consulter votre dashboard."}
            </p>
            <Button onClick={() => navigate("/dashboard")} variant="outline" className="rounded-full">
              Retour au dashboard
            </Button>
          </>
        )}
      </div>
    </Layout>
  );
}
